import { PrinterPosOffOutlineIcon } from './PrinterPosOffOutlineIcon';

/**
 * author: Colton Wiscombe
 * id B5A792CB-A191-44B7-AC15-148FC242803E
 * name printer-pos-off-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-off-outline.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptOffOutlineIcon = PrinterPosOffOutlineIcon;
export default PrinterReceiptOffOutlineIcon